import { css } from '@emotion/css';
import {
  Accordion as AccordionComponent,
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
} from '@prezzee/components';
import { useProduct } from 'contexts/ProductPageContext';
import ReactMarkdown from 'react-markdown';

const style = {
  title: css`
    font-weight: 600;
  `,
  accordionPanel: css`
    font-weight: 300;
    padding-bottom: 20px;

    p {
      margin-bottom: 1em;
    }

    ul,
    ol {
      margin-bottom: 1em;
      list-style: inherit;
      padding-left: 2.5em;
    }
  `,
};

const FullCardDetails = () => {
  const { sku } = useProduct() || {};

  if (!sku.description) return null;

  return (
    <AccordionComponent allowZeroExpanded variant="secondary">
      <AccordionItem>
        <AccordionItemHeading>
          <AccordionItemButton>Read the full details</AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel className={style.accordionPanel}>
          <ReactMarkdown>{sku.description}</ReactMarkdown>
        </AccordionItemPanel>
      </AccordionItem>
    </AccordionComponent>
  );
};

export default FullCardDetails;
